<!DOCTYPE html>
<div class="app-update-wrapper">
  <img class="corner" src="../../../assets/icon/corner-1.svg" alt="corner first" />
  <img class="corner" src="../../../assets/icon/corner-2.svg" alt="corner second" />
  <p class="app-update-icon">😅</p>
  <p class="app-update-heading">{{ "popup.Oops" | translate }}</p>
  <p class="app-update-content">{{ "popup.Page_hiccup" | translate }}</p>

  <div class="options-container">
    <div class="option">
      <button class="option-btn wait-btn" (click)="wait()">{{ "popup.Wait" | translate }}</button>
      <p class="option-description">{{ "popup.Wait_description" | translate }}</p>
    </div>

    <div class="option">
      <button class="option-btn refresh-btn" [disabled]="isLoading" (click)="reload()">
        @if(isLoading) {
        <ion-spinner name="dots"></ion-spinner>
        } @else {
        <span>{{ "popup.Refresh" | translate }}</span>
        }
      </button>
      <p class="option-description">{{ "popup.Refresh_description" | translate }}</p>
    </div>

    <div class="option">
      <button class="option-btn reset-btn" [disabled]="isLoading" (click)="reset()">
        {{ "popup.Reset" | translate }}
      </button>
      <p class="option-description">{{ "popup.Reset_description" | translate }}</p>
    </div>
  </div>
</div>
